import React, { useState } from "react";
import toast from "react-hot-toast";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { LoadingButton } from "@mui/lab";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

function DownloadConfirmDialog(props) {
  const { open, title, message, onConfirm, handleCloseDialog } = props;
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onConfirm();
      handleCloseDialog();
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) handleCloseDialog();
  };

  return (
    <Dialog open={open} onClose={handleClose} slotProps={{ paper: { sx: { overflowX: "hidden" } } }}>
      <DialogTitle>
        <Grid container display={"flex"}>
          <Grid item xs={10} sm={11} display={"flex"} justifyContent={"center"} alignItems={"center"}>
            <Typography fontSize={18} fontWeight={500}>
              {title}
            </Typography>
          </Grid>
          <Grid item xs={1} display={"flex"} alignItems={"center"}>
            <IconButton onClick={handleClose} className="closeButton" disabled={loading}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <Typography fontSize={14}>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Grid container display={"flex"} gap={2} justifyContent={"center"} my={1}>
          <Button variant={"outlined"} onClick={handleClose} disabled={loading} sx={{ padding: "6px 28px 6px 28px" }}>
            Cancel
          </Button>
          <LoadingButton
            loading={loading}
            loadingPosition="start"
            variant={"contained"}
            onClick={handleConfirm}
            sx={{
              padding: "6px 28px 6px 28px",
              "& .MuiLoadingButton-loadingIndicatorStart": { position: "relative", left: 0, marginRight: 1 },
            }}
          >
            Confirm
          </LoadingButton>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}

export default DownloadConfirmDialog;
